import { ref } from 'vue'

export function createCalculationsState() {
    function getInitialFilters() {
        return {
            search: null,
            status_ids: null,
            customerName: null,
            createdBy_id: null,
            createdAt__gte: null,
            createdAt__lte: null
        }
    }

    return {
        calculations: ref([]),
        calculationsLoading: ref(false),
        calculation: ref(null),
        calculationLoading: ref(false),
        calculationResourcesLoading: ref(false),
        calculationMachines: ref([]),
        calculationPapers: ref([]),
        calculationPaperCertificates: ref([]),
        calculationColourTemplates: ref([]),
        calculationElasticMaterials: ref([]),
        calculationDieCutters: ref([]),
        calculationDieCutterOwnershipTypes: ref([]),
        calculationStatusList: ref([]),
        filters: ref(getInitialFilters())
    }
}
